var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.398,
    cy: 130.602,
    r: 109.398,
    fill: "url(#paint0_linear_62_7561)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_7561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.087 130.914C98.0651 119.892 80.1752 119.892 69.1521 130.914C59.5674 140.498 49.9459 177.915 48.7473 184.704L47.2295 192.771L55.2964 191.253C62.0853 190.056 99.5035 180.432 109.087 170.848C120.108 159.827 120.108 141.935 109.087 130.914Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.087 170.848C99.5035 180.432 62.0853 190.055 55.2964 191.253L47.2295 192.771L109.087 130.914C120.108 141.935 120.108 159.827 109.087 170.848Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.067 158.868L105.094 142.894V134.907H97.1064L81.1328 118.933L113.08 102.96L137.041 126.921L121.067 158.868Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.041 126.921L121.067 158.868L105.094 142.894V134.907L125.06 114.94L137.041 126.921Z",
    fill: "#F10D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.976 118.933L180.97 122.926C187.585 129.543 187.585 140.271 180.97 146.887L145.028 182.829L141.035 178.835C134.419 172.219 134.419 161.492 141.035 154.875L145.028 150.88V134.907L161.002 118.933H176.976Z",
    fill: "#F10D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.067 63.025L117.074 59.0319C110.457 52.4151 99.7298 52.4151 93.113 59.0319L57.1714 94.9721L61.1659 98.9651C67.7827 105.582 78.5087 105.582 85.1255 98.9651L89.12 94.9721H105.094L121.067 78.9985V63.025Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.032 79.8767L145.028 150.88L89.1201 94.9722L160.124 23.9685C167.791 16.3016 176.736 10.3907 186.479 6.39771L233.603 53.5198C229.61 63.2648 223.699 72.2098 216.032 79.8767Z",
    fill: "#DEECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.032 79.8766L145.028 150.88L117.074 122.926L210.042 29.9587L233.603 53.5197C229.61 63.2648 223.699 72.2097 216.032 79.8766Z",
    fill: "#A8D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.969 59.0321C174.34 52.4021 163.638 52.4021 157.008 59.0321C150.379 65.6607 150.379 76.3632 157.008 82.9932C163.638 89.6218 174.34 89.6218 180.969 82.9932C187.599 76.3632 187.599 65.6607 180.969 59.0321Z",
    fill: "#73BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1064 134.907L145.027 86.9861L153.013 94.9721L105.092 142.893L97.1064 134.907Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.009 82.9915L180.97 59.032C187.598 65.6605 187.598 76.363 180.97 82.9915C174.34 89.6201 163.637 89.6216 157.009 82.9915Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.099 138.9L149.02 90.979L153.013 94.972L105.092 142.893L101.099 138.9Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.603 53.5196C220.824 56.3949 206.846 52.9608 196.944 43.0569C187.04 33.1545 183.606 19.1767 186.481 6.39757C201.256 0.248462 217.709 -1.66937 234.001 1.52505L237.677 2.32366L238.475 5.999C241.67 22.2917 239.752 38.7447 233.603 53.5196Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.943 43.057L237.677 2.32373L238.475 5.99908C241.67 22.2918 239.752 38.7448 233.603 53.5212C220.824 56.3965 206.846 52.9608 196.943 43.057Z",
    fill: "#F10D35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_7561",
    x1: 109.398,
    y1: 21.2048,
    x2: 313.929,
    y2: 353.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ABBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062F36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_7561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192.771,
    height: 192.771,
    fill: "white",
    transform: "translate(47.2295)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b2a03ab6e3a42b3da637122799616148.svg";
export { ForwardRef as ReactComponent };